import { Dispatch, SetStateAction } from 'react'
import { ActivityJson } from 'app/types/entities'
import { useActivityStore } from 'app/stores/StoreContext'
import { notifyError } from 'app/services/notify.client'
import { SearchResponse } from 'app/services/search'
import { IndexProperties } from 'app/types/entities'
import { logError } from 'lib/logging'

/** Reloads a single activity from the API and updates both the focused activity and the list. */
export function useActivityReload(
  setFocusedActivity: Dispatch<SetStateAction<ActivityJson | undefined>>,
  setActivities: Dispatch<SetStateAction<SearchResponse<ActivityJson> | undefined>>,
) {
  const store = useActivityStore()

  return async (id: string) => {
    const result = await store.fetchOne(id)
    if (result.error || !result.data) {
      logError(`Error loading activity`, result.error?.message)
      notifyError(`Activity not saved ${result.error?.message ?? ``}`)
      return
    }
    const updated = store.current as unknown as ActivityJson
    setFocusedActivity(updated)
    setActivities((prev) => {
      const hits = [...(prev?.hits ?? [])].map((act) =>
        act.id === updated.id ? (updated as IndexProperties<ActivityJson>) : act,
      )
      return { total: prev?.total ?? 0, page: prev?.page ?? 0, hits }
    })
  }
}
